import { render, staticRenderFns } from "./subNoInputList.vue?vue&type=template&id=39471f13&scoped=true"
import script from "./subNoInputList.vue?vue&type=script&lang=js"
export * from "./subNoInputList.vue?vue&type=script&lang=js"
import style0 from "./subNoInputList.vue?vue&type=style&index=0&id=39471f13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39471f13",
  null
  
)

export default component.exports